export default __webpack_public_path__ + "static/media/balmain_4.2784d594.jpg";